import { AbstractControl, ValidationErrors } from '@angular/forms';

export const countryCodesValidator = (control: AbstractControl): ValidationErrors | null => {
  let code;
  const codeValue = control.value;
  const codeArray = [];
  if (codeValue && codeValue !== null) {
    codeArray.push(codeValue);
    for (const val of codeArray[0]) {
      code = val.length;
    }
  }
  if (!code) {
    return null;
  }
  if (code < 2 || code > 2) {
    return {
      countryCodesValidator: {
        requiredValue: 2
      }
    };
  }
  return null;
};
